<template>

<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=AW-974148699"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'AW-974148699');
</script>

  <div class="thank-you">
    <h1>Thank You!</h1>
    <h4>Your message has been sent. I’ll be in touch soon.</h4>
    <h4>Return home <a href="/">here.</a></h4>
  </div>
</template>

<script>
export default {
  name: "ThankYou",
}
</script>

<style scoped>
.thank-you {
  text-align: center;
  background-color: rgb(255, 240, 245);
  padding: 2rem;
}
</style>
